import {createContext, useContext} from "react";

type IntellsysConfigurationContextData = {
    // hadesBaseUrl: string;
    intellsysBaseUrl: string;
};

export const IntellsysConfigurationContext = createContext<IntellsysConfigurationContextData | undefined>(undefined);

export function useIntellsysConfiguration(): IntellsysConfigurationContextData {
    const intellsysConfigurationContextData = useContext(IntellsysConfigurationContext);
    if (intellsysConfigurationContextData === undefined) {
        throw new Error("IntellsysConfigurationContext.Provider not found");
    }

    return intellsysConfigurationContextData;
}
